import { Link } from 'react-router-dom';

import useAdvertisementBanner from './useAdvertisementBanner';

const AdvertisementBanner = () => {
  const { advertisement } = useAdvertisementBanner();

  if (!advertisement) {
    return null;
  }

  return (
    <aside className="md:size-[512px] md:sticky md:top-[160px] flex items-start mt-[46px]">
      <Link
        to={advertisement.link_url}
        target="_blank"
        rel="noopener noreferrer"
      >
        <img
          src={advertisement.image_url}
          alt="Lanetalk banner"
          className="w-full object-contain"
        />
      </Link>
    </aside>
  );
};

export default AdvertisementBanner;
